import { useState } from "react";
import { FileText } from "lucide-react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { OverviewTab } from "@/components/reports/OverviewTab";
import { FinancialTab } from "@/components/reports/FinancialTab";
import { OperationsTab } from "@/components/reports/OperationsTab";
import { DataHealthTab } from "@/components/reports/DataHealthTab";
import { AIInsightsTab } from "@/components/reports/AIInsightsTab";
import { AuditTab } from "@/components/reports/AuditTab";
import { CustomReportsTab } from "@/components/reports/CustomReportsTab";
import { useSearchParams } from "react-router-dom";
import { useAuthContext } from "@/contexts/AuthContext";

export default function Reports() {
  const [searchParams, setSearchParams] = useSearchParams();
  const { isPlatformOwner } = useAuthContext();
  const defaultTab = searchParams.get("tab") || "overview";
  
  const handleTabChange = (value: string) => {
    setSearchParams({ tab: value });
  };

  // Count visible tabs for grid cols
  const tabCount = isPlatformOwner ? 7 : 5;

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <div className="flex items-center gap-3 mb-2">
            <div className="p-2 rounded-lg bg-gradient-to-br from-primary to-primary-glow">
              <FileText className="w-6 h-6 text-primary-foreground" />
            </div>
            <h1 className="text-3xl font-bold">Reports Hub</h1>
          </div>
          <p className="text-muted-foreground">
            Comprehensive reporting and analytics dashboard
          </p>
        </div>
      </div>

      <Tabs value={defaultTab} onValueChange={handleTabChange} className="w-full">
        <TabsList className={`grid w-full h-auto`} style={{ gridTemplateColumns: `repeat(${tabCount}, minmax(0, 1fr))` }}>
          <TabsTrigger value="overview" className="text-xs sm:text-sm py-2">Overview</TabsTrigger>
          <TabsTrigger value="financial" className="text-xs sm:text-sm py-2">Financial</TabsTrigger>
          <TabsTrigger value="operations" className="text-xs sm:text-sm py-2">Operations</TabsTrigger>
          <TabsTrigger value="data-health" className="text-xs sm:text-sm py-2">Data Health</TabsTrigger>
          <TabsTrigger value="custom-reports" className="text-xs sm:text-sm py-2">AI Reports</TabsTrigger>
          {isPlatformOwner && (
            <TabsTrigger value="ai-insights" className="text-xs sm:text-sm py-2">AI Insights</TabsTrigger>
          )}
          {isPlatformOwner && (
            <TabsTrigger value="audit" className="text-xs sm:text-sm py-2">AI Audit</TabsTrigger>
          )}
        </TabsList>

        <TabsContent value="overview" className="mt-6">
          <OverviewTab />
        </TabsContent>

        <TabsContent value="financial" className="mt-6">
          <FinancialTab />
        </TabsContent>

        <TabsContent value="operations" className="mt-6">
          <OperationsTab />
        </TabsContent>

        <TabsContent value="data-health" className="mt-6">
          <DataHealthTab />
        </TabsContent>

        <TabsContent value="custom-reports" className="mt-6">
          <CustomReportsTab />
        </TabsContent>

        {isPlatformOwner && (
          <TabsContent value="ai-insights" className="mt-6">
            <AIInsightsTab />
          </TabsContent>
        )}

        {isPlatformOwner && (
          <TabsContent value="audit" className="mt-6">
            <AuditTab />
          </TabsContent>
        )}
      </Tabs>
    </div>
  );
}
